/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import {
  Button,
  Chip,
  Divider,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
  useTheme,
} from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import _ from "lodash";
import React, { useEffect } from "react";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

import { CustomTheme, Theme } from "../../../../types/customTheme";
import TextfieldDefault from "../../../../components/textField/TextfieldDefault";
import { INTEGER_NUMBER_PATTERN } from "../../../../utils/consts";
import ValidationMessage from "../../../../components/validation/ValidationMessage";
import ButtonCommon from "../../../../components/buttons/ButtonCommon";
import { Autocomplete } from "@material-ui/lab";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import SwitchCommon from "../../../../components/switches/SwitchCommon";
import { DeliveryTpe, submitButtonName } from "../../../../utils/enum";
import AvailabilitySelection from "../../../../components/time/AvailabilitySelection";
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment";
import FirstTwoTypesGroup from "./FirstTwoTypesGroup";
import ThirdTypeGroup from "./ThirdTypeGeoup";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textField: {
      overflowWrap: "break-word",
      wordWrap: "break-word",
    },
    base: {
      padding: "0px 12px 0 12px",
      [theme.breakpoints.up("sm")]: {
        padding: "0px 16px 0 16px",
      },
      borderRadius: 4,
    },
    error: {
      backgroundColor: theme.palette.error.dark,
      borderRadius: "8px 8px 0 0",
      border: `1px solid ${theme.palette.background.entity_border_highlight_background}`,
      padding: 8,
    },
    actionsWrapper: {
      padding: "16px 16px",
      display: "flex",
      justifyContent: "center",
    },
    autoComplete: {
      marginTop: "4px",
      "& .MuiAutocomplete-input": {
        color: theme.palette.custom.orange.contrastText,
      },
      "& .MuiInputBase-root": {
        color: "inherit",
        backgroundColor: theme.palette.background.entity_background,
        borderRadius: 10,
      },
      [`& fieldset`]: {
        borderRadius: 10,
        border: `1px solid ${theme.palette.background.entity_border_highlight_background}`,
        color: theme.palette.custom.orange.contrastText,
      },
      "& .MuiAutocomplete-option": {
        paddingTop: 8,
        paddingBottom: 8,
      },
    },
    datePickerStyle: {
      [`& fieldset`]: {
        borderRadius: "10px",
        border: `1px solid ${theme.palette.background.entity_border_highlight_background}`,
        cursor: "pointer",
      },
      "& .MuiPickersClockPointer-pointer": {
        backgroundColor: `${theme.palette.background.default} !important`,
      },
      "& .MuiPickersClockNumber-clockNumberSelected": {
        backgroundColor: `${theme.palette.background.default} !important`,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${theme.palette.background.entity_border_highlight_background}`,
      },
      "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `1px solid ${theme.palette.background.entity_border_highlight_background}`,
      },
    },
    titleColor: {
      color: theme.palette.custom.orange.contrastText,
    },
  }),
);

export interface DiscountInfoNodeProps {
  register: any;
  errors: any;
  handleOpenProductsAddModal: any;
  selectedWrapperIdList: any;
  isMembersEmpty: any;
  deliveryTypesList: any;
  success: any;
  setSuccess: any;
  error: any;
  isActive: any;
  handleSwitchActivate: any;
  handleSelectDeliveryTypes: any;
  isDeliveryTypeEmpty: any;
  isOpenCriticalType: any;
  setIsOpenCriticalType: any;
  offerTypeList: any;
  selectedOfferType: any;
  handleChangeOfferType: any;
  isOfferTypeEmpty: any;
  isPlatformEmpty: any;
  isApplyToEmpty: any;
  isOpenPriority: any;
  setIsOpenPriority: any;
  isOpenUsageLimitType: any;
  setIsOpenUsageLimitType: any;
  isOpenPlatform: any;
  setIsOpenPlatform: any;
  isOpenDiscountMethod: any;
  setIsOpenDiscountMethod: any;
  isOpenApplyTo: any;
  setIsOpenApplyTo: any;
  selectedPriorityType: any;
  selectedUsageLimitType: any;
  selectedPlatform: any;
  selectedDiscountMethod: any;
  selectedApplyTo: any;
  handleChangePriorityType: any;
  handleChangeUsageLimitType: any;
  platformList: any;
  handleChangePlatform: any;
  availabilitySelectionList: any;
  handleChangeDiscountMethod: any;
  handleChangeApplyTo: any;
  handleSubmitAvailability: any;
  setAvailabilityErrorMessage: any;
  availabilityErrorMessage: any;
  isSwitchActive: any;
  handleSelectSwitchActivate: any;
  fromDate: any;
  toDate: any;
  handleChangeFromDate: any;
  handleChangeToDate: any;
  isSelectedMethodEmpty: any;
  isAllowRepeatInBasket: any;
  handleAllowRepeatInBasketActivate: any;
  setGroupInfo: any;
  groupInfo: any;
  isLoadingButton: any;
  setOpenDialog: any;
  handleSubmitData: any;
  offerItemMap: any;
  setOfferItemMap: any;
  offerItemMapInitial: any;
  selectedWrapperIdListInitialNew: any;
  offerName: any;
}
const discountMethodList = [
  { id: "PERCENTAGE", label: "Percentage" },
  { id: "FIXED", label: "Fixed" },
  { id: "FREE", label: "Free" },
];

const applyToList = [
  { id: "CHEAPEST", label: "Cheapest" },
  { id: "MOST_EXPENSIVE", label: "Most Expensive" },
];

/* Create, delete, and update discount information and users can view all discount information. */
const OfferModalDialog: React.FunctionComponent<DiscountInfoNodeProps> = ({
  register,
  errors,
  handleOpenProductsAddModal,
  selectedWrapperIdList,
  isMembersEmpty,
  deliveryTypesList,
  success,
  setSuccess,
  error,
  isActive,
  handleSwitchActivate,
  handleSelectDeliveryTypes,
  isDeliveryTypeEmpty,
  isOpenCriticalType,
  setIsOpenCriticalType,
  offerTypeList,
  selectedOfferType,
  handleChangeOfferType,
  isOfferTypeEmpty,
  isPlatformEmpty,
  isApplyToEmpty,
  isOpenPriority,
  setIsOpenPriority,
  isOpenUsageLimitType,
  setIsOpenUsageLimitType,
  isOpenPlatform,
  setIsOpenPlatform,
  isOpenDiscountMethod,
  setIsOpenDiscountMethod,
  isOpenApplyTo,
  setIsOpenApplyTo,
  selectedPriorityType,
  selectedUsageLimitType,
  selectedPlatform,
  selectedDiscountMethod,
  selectedApplyTo,
  handleChangePriorityType,
  handleChangeUsageLimitType,
  platformList,
  handleChangePlatform,
  availabilitySelectionList,
  handleChangeDiscountMethod,
  handleChangeApplyTo,
  handleSubmitAvailability,
  setAvailabilityErrorMessage,
  availabilityErrorMessage,
  isSwitchActive,
  handleSelectSwitchActivate,
  fromDate,
  toDate,
  handleChangeFromDate,
  handleChangeToDate,
  isSelectedMethodEmpty,
  isAllowRepeatInBasket,
  handleAllowRepeatInBasketActivate,
  setGroupInfo,
  groupInfo,
  isLoadingButton,
  setOpenDialog,
  handleSubmitData,
  offerItemMap,
  setOfferItemMap,
  offerItemMapInitial,
  selectedWrapperIdListInitialNew,
  offerName,
}) => {
  const classes = useStyles();
  const theme: CustomTheme = useTheme();
  return (
    <>
      <Grid>
        <DefaultAlert
          open={!!success}
          handleClose={() => setSuccess("")}
          message={success}
          severity={"success"}
        />
        {error && (
          <Typography component="div" className={classes.error} variant="body1">
            {error}
          </Typography>
        )}
        <Grid container spacing={2}>
          <Grid
            container
            spacing={2}
            xs={6}
            style={{
              placeItems: "center",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <FormControlLabel
              control={<SwitchCommon />}
              checked={isActive}
              onChange={handleSwitchActivate}
              label={
                <Typography variant="caption" color="textSecondary">
                  Active
                </Typography>
              }
              labelPlacement="bottom"
            />
          </Grid>
          <Grid item xs={6}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <FormControlLabel
                style={{ marginLeft: "0px", marginRight: "0px" }}
                value="dinein"
                control={<SwitchCommon />}
                label={
                  <Typography variant="caption" color="textSecondary">
                    Dine In
                  </Typography>
                }
                name="dinein"
                checked={
                  !_.isEmpty(deliveryTypesList)
                    ? deliveryTypesList.includes(DeliveryTpe.DINEIN)
                    : false
                }
                labelPlacement="bottom"
                onChange={handleSelectDeliveryTypes}
              />
              <FormControlLabel
                style={{ marginLeft: "0px", marginRight: "0px" }}
                value="delivery"
                control={<SwitchCommon />}
                label={
                  <Typography variant="caption" color="textSecondary">
                    Delivery
                  </Typography>
                }
                name="delivery"
                checked={
                  !_.isEmpty(deliveryTypesList)
                    ? deliveryTypesList.includes(DeliveryTpe.DELIVERY)
                    : false
                }
                labelPlacement="bottom"
                onChange={handleSelectDeliveryTypes}
              />
              <FormControlLabel
                style={{ marginLeft: "0px", marginRight: "0px" }}
                value="takeout"
                name="takeout"
                control={<SwitchCommon />}
                label={
                  <Typography variant="caption" color="textSecondary">
                    Takeout
                  </Typography>
                }
                checked={
                  !_.isEmpty(deliveryTypesList)
                    ? deliveryTypesList.includes(DeliveryTpe.TAKEOUT)
                    : false
                }
                labelPlacement="bottom"
                onChange={handleSelectDeliveryTypes}
              />
            </div>
            {_.isEqual(isDeliveryTypeEmpty, true) && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "start",
                  marginBottom: "3px",
                }}
              >
                <Typography
                  align="left"
                  variant="caption"
                  style={{ color: "red" }}
                >
                  Please select a least one delivery option.
                </Typography>
              </div>
            )}
          </Grid>
        </Grid>
        <Divider variant="fullWidth" style={{ margin: "4px 0 8px 0" }} />

        <Grid container spacing={2}>
          <Grid item xs={12} style={{ marginTop: "8px" }}>
            <Typography variant="body2" style={{ fontWeight: "bold" }}>
              Name
            </Typography>
            <TextfieldDefault
              id="name"
              name="name"
              type="text"
              label=""
              style={{
                border: `1px solid ${theme.palette.background.entity_border}`,
              }}
              inputRef={register({
                required: "Name is required",
                minLength: {
                  value: 2,
                  message: "Minimum Character is 2",
                },
                maxLength: {
                  value: 30,
                  message: "Maximum Character is 30",
                },
              })}
            />
            {errors.name ? (
              <ValidationMessage message={errors.name.message} />
            ) : (
              ""
            )}
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" style={{ fontWeight: "bold" }}>
              Description
            </Typography>
            <TextfieldDefault
              id="description"
              name="description"
              type="text"
              label=""
              multiline={true}
              rows={4}
              style={{
                border: `1px solid ${theme.palette.background.entity_border}`,
              }}
              inputRef={register({
                minLength: {
                  value: 2,
                  message: "Minimum Character is 2",
                },
              })}
            />
            {errors.description ? (
              <ValidationMessage message={errors.description.message} />
            ) : (
              ""
            )}
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" style={{ fontWeight: "bold" }}>
              Offer Type
            </Typography>
            <Autocomplete
              open={isOpenCriticalType}
              onOpen={() => setIsOpenCriticalType(true)}
              onClose={() => setIsOpenCriticalType(false)}
              size="small"
              id="offerTypeSelect"
              color="inherit"
              options={offerTypeList}
              value={selectedOfferType}
              getOptionLabel={(option: any) => option.label || ""}
              disableClearable
              onChange={handleChangeOfferType}
              classes={{ root: classes.autoComplete }}
              popupIcon={<ArrowDropDownIcon color="inherit" />}
              renderOption={(option) => (
                <Grid container direction="column">
                  <Typography variant="body2" className={classes.titleColor}>
                    {option.label}
                  </Typography>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                    style={{
                      marginTop: 2,
                      color: theme.palette.custom.orange.contrastText,
                    }}
                  >
                    {option.desc}
                  </Typography>
                </Grid>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label=""
                  placeholder=""
                  variant="outlined"
                />
              )}
            />
            {_.isEqual(isOfferTypeEmpty, true) && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "start",
                  marginBottom: "3px",
                }}
              >
                <Typography
                  align="left"
                  variant="caption"
                  style={{ color: "red" }}
                >
                  Please select a Offer.
                </Typography>
              </div>
            )}
          </Grid>
          {/* <Grid item xs={6}>
            <Typography
              variant="body2"
              style={{ fontWeight: "bold", marginBottom: "10px" }}
            >
              Priority
            </Typography>
            <Autocomplete
              open={isOpenPriority}
              onOpen={() => setIsOpenPriority(true)}
              onClose={() => setIsOpenPriority(false)}
              size={"small"}
              id="locationSelectGlobal"
              color="inherit"
              options={priorityList}
              value={selectedPriorityType}
              getOptionLabel={(option: any) => option.label || ""}
              disableClearable
              onChange={handleChangePriorityType}
              classes={{ root: classes.autoComplete }}
              popupIcon={<ArrowDropDownIcon color={"inherit"} />}
              renderOption={(props: any) => {
                return (
                  <Grid
                    container
                    {...props}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      zIndex: 0,
                      height: "20px",
                      marginBottom: "4px",
                    }}
                  >
                    <Grid item xs={12}>
                      <Typography
                        variant="body2"
                        className={classes.titleColor}
                      >
                        {props.label}
                      </Typography>
                    </Grid>
                  </Grid>
                );
              }}
              renderInput={(params: any) => (
                <TextField
                  color="inherit"
                  {...params}
                  label=""
                  placeholder=""
                  variant="outlined"
                />
              )}
            />
          </Grid> */}
          <Grid item xs={6}>
            <Typography variant="body2" style={{ fontWeight: "bold" }}>
              Min Order Price
            </Typography>
            <TextfieldDefault
              id="minOrderPrice"
              name="minOrderPrice"
              type="number"
              label=""
              style={{
                border: `1px solid ${theme.palette.background.entity_border}`,
              }}
              inputRef={register({
                required: "Min Order Price is required",
              })}
            />
            {errors.minOrderPrice ? (
              <ValidationMessage message={errors.minOrderPrice.message} />
            ) : (
              ""
            )}
          </Grid>
          {/* <Grid item xs={6}>
            <Typography
              variant="body2"
              style={{ fontWeight: "bold", marginBottom: "10px" }}
            >
              Usage Limit Type
            </Typography>
            <Autocomplete
              open={isOpenUsageLimitType}
              onOpen={() => setIsOpenUsageLimitType(true)}
              onClose={() => setIsOpenUsageLimitType(false)}
              size={"small"}
              id="locationSelectGlobal"
              color="inherit"
              options={usageList}
              value={selectedUsageLimitType}
              getOptionLabel={(option: any) => option.label || ""}
              disableClearable
              disabled={true}
              onChange={handleChangeUsageLimitType}
              classes={{ root: classes.autoComplete }}
              popupIcon={<ArrowDropDownIcon color={"inherit"} />}
              renderOption={(props: any) => {
                return (
                  <Grid
                    container
                    {...props}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      zIndex: 0,
                      height: "20px",
                      marginBottom: "4px",
                    }}
                  >
                    <Grid item xs={12}>
                      <Typography
                        variant="body2"
                        className={classes.titleColor}
                      >
                        {props.label}
                      </Typography>
                    </Grid>
                  </Grid>
                );
              }}
              renderInput={(params: any) => (
                <TextField
                  color="inherit"
                  {...params}
                  label=""
                  placeholder=""
                  variant="outlined"
                />
              )}
            />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" style={{ fontWeight: "bold" }}>
              Usage limit
            </Typography>
            <TextfieldDefault
              id="usageLimit"
              name="usageLimit"
              type="number"
              label=""
              disabled={true}
              style={{
                border: `1px solid ${theme.palette.background.entity_border}`,
              }}
              inputRef={register({
                required: "Usage Limit is required.",
                pattern: {
                  value: INTEGER_NUMBER_PATTERN,
                  message: "Invalid limit entered",
                },
              })}
            />
          </Grid> */}
          <Grid item xs={6} style={{ marginTop: "4px", marginBottom: "20px" }}>
            <Typography variant="body2" style={{ fontWeight: "bold" }}>
              Applicable Platforms
            </Typography>
            <Autocomplete
              open={isOpenPlatform}
              onOpen={() => setIsOpenPlatform(true)}
              onClose={() => setIsOpenPlatform(false)}
              size={"small"}
              id="locationSelectGlobal"
              value={selectedPlatform || []} // Ensure value is always an array
              getOptionLabel={(option) => option.label || ""}
              color="inherit"
              multiple={true}
              disableCloseOnSelect
              options={platformList}
              disableClearable
              onChange={handleChangePlatform}
              classes={{ root: classes.autoComplete }}
              popupIcon={<ArrowDropDownIcon color={"inherit"} />}
              renderOption={(props: any) => {
                return (
                  <Grid
                    container
                    {...props}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      zIndex: 0,
                      height: "20px",
                      marginBottom: "4px",
                    }}
                  >
                    <Grid item xs={12}>
                      <Typography
                        variant="body2"
                        className={classes.titleColor}
                      >
                        {props.label}
                      </Typography>
                    </Grid>
                  </Grid>
                );
              }}
              // renderTags={(value, props) =>
              //   value.map((option, index) => (
              //     <Chip label={option} {...props({ index })} />
              //   ))
              // }
              renderInput={(params: any) => (
                <TextField
                  color="inherit"
                  {...params}
                  label=""
                  variant="outlined"
                />
              )}
            />
            {isPlatformEmpty && (
              <ValidationMessage message={"Platform is required."} />
            )}
          </Grid>
        </Grid>

        <AvailabilitySelection
          nodeData={{ availability: availabilitySelectionList }}
          backgroundColor="entity_background"
          disabled={false}
          handleSubmit={handleSubmitAvailability}
          setAvailabilityErrorMessage={setAvailabilityErrorMessage}
          title={"Set Availability Times"}
        />
        {availabilityErrorMessage && (
          <ValidationMessage
            message={"Please create a discount before updating."}
          />
        )}

        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            style={{
              placeItems: "center",
              display: "flex",
              justifyContent: "start",
              paddingTop: "16px",
            }}
          >
            <FormControlLabel
              style={{ marginLeft: "0px", marginRight: "0px" }}
              control={<SwitchCommon />}
              checked={isSwitchActive}
              onChange={handleSelectSwitchActivate}
              label="Limited Time"
              labelPlacement="start"
            />{" "}
          </Grid>

          {isSwitchActive && (
            <Grid item xs={6}>
              <Typography variant="body2" style={{ fontWeight: "bold" }}>
                From Date
              </Typography>
              <KeyboardDatePicker
                autoOk
                label=""
                value={fromDate}
                onChange={handleChangeFromDate}
                inputVariant={"outlined"}
                fullWidth
                margin="normal"
                className={classes.datePickerStyle}
                format="dd/MM/yyyy"
                okLabel={<Typography color="secondary">Ok</Typography>}
                cancelLabel={<Typography color="secondary">Cancel</Typography>}
                InputProps={{
                  style: {
                    borderRadius: 10,
                    height: 56,
                    backgroundColor: theme.palette.background.entity_background,
                  },
                }}
              />
            </Grid>
          )}
          {isSwitchActive && (
            <Grid item xs={6}>
              <Typography variant="body2" style={{ fontWeight: "bold" }}>
                To Date
              </Typography>
              <KeyboardDatePicker
                autoOk
                label=""
                value={toDate}
                disablePast
                minDate={moment(fromDate)}
                onChange={handleChangeToDate}
                inputVariant={"outlined"}
                fullWidth
                margin="normal"
                className={classes.datePickerStyle}
                okLabel={<Typography color="secondary">Ok</Typography>}
                cancelLabel={<Typography color="secondary">Cancel</Typography>}
                InputProps={{
                  style: {
                    borderRadius: 10,
                    height: 56,
                    backgroundColor: theme.palette.background.entity_background,
                  },
                }}
                format="dd/MM/yyyy"
              />
            </Grid>
          )}
          <Grid item xs={12}>
            {(selectedOfferType.id === "BUY_X_GET_Y_CHEAPEST_DISCOUNTED" ||
              selectedOfferType.id === "FIXED_PRICE_FOR_X_ITEMS") && (
              <FirstTwoTypesGroup
                register={register}
                errors={errors}
                handleOpenProductsAddModal={handleOpenProductsAddModal}
                selectedWrapperIdList={selectedWrapperIdList}
                isMembersEmpty={isMembersEmpty}
                selectedOfferType={selectedOfferType.id}
              />
            )}
          </Grid>
          {selectedOfferType?.id === "BUY_X_GET_Y_CHEAPEST_DISCOUNTED" && (
            <Grid item xs={12}>
              <Typography variant="body2" style={{ fontWeight: "bold" }}>
                Get (number of discounted items)
              </Typography>
              <Typography variant="caption" style={{ paddingTop: "12px" }}>
                Number of items that will receive a discount (e.g. cheapest free
                or 50% off). (Example: in “Buy 2 get 1 free”, this would be 1.)
              </Typography>
              <TextfieldDefault
                id="discountedQuantity"
                name="discountedQuantity"
                type="number"
                label=""
                style={{
                  border: `1px solid ${theme.palette.background.entity_border}`,
                }}
                inputRef={register({
                  required: "Discounted Quantity is required.",
                  pattern: {
                    value: INTEGER_NUMBER_PATTERN,
                    message: "Invalid limit entered",
                  },
                  min: {
                    value: 1,
                    message: "Discounted Quantity greater than 0",
                  },
                })}
              />
              {errors.discountedQuantity ? (
                <ValidationMessage
                  message={errors.discountedQuantity.message}
                />
              ) : (
                ""
              )}
            </Grid>
          )}

          {selectedOfferType?.id === "BUY_X_GET_Y_CHEAPEST_DISCOUNTED" && (
            <Grid
              item
              xs={selectedDiscountMethod?.id === "FREE" ? 6 : 4}
              style={{ marginTop: "4px", marginBottom: "4px" }}
            >
              <Typography
                variant="body2"
                style={{ fontWeight: "bold", marginBottom: "2px" }}
              >
                Discount Method
              </Typography>
              <Autocomplete
                open={isOpenDiscountMethod}
                onOpen={() => setIsOpenDiscountMethod(true)}
                onClose={() => setIsOpenDiscountMethod(false)}
                size={"small"}
                id="locationSelectGlobal"
                value={selectedDiscountMethod || []} // Ensure value is always an array
                getOptionLabel={(option) => option.label || ""}
                color="inherit"
                options={discountMethodList}
                disableClearable
                disabled={
                  selectedOfferType.id !== "BUY_X_GET_Y_CHEAPEST_DISCOUNTED"
                }
                onChange={handleChangeDiscountMethod}
                classes={{ root: classes.autoComplete }}
                popupIcon={<ArrowDropDownIcon color={"inherit"} />}
                renderOption={(props: any) => {
                  return (
                    <Grid
                      container
                      {...props}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        zIndex: 0,
                        height: "22px",
                        marginBottom: "4px",
                      }}
                    >
                      <Grid item xs={12}>
                        <Typography
                          variant="body2"
                          className={classes.titleColor}
                        >
                          {props.label}
                        </Typography>
                      </Grid>
                    </Grid>
                  );
                }}
                // renderTags={(value, props) =>
                //   value.map((option, index) => (
                //     <Chip label={option} {...props({ index })} />
                //   ))
                // }
                renderInput={(params: any) => (
                  <TextField
                    color="inherit"
                    {...params}
                    label=""
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      style: { height: 42 },
                    }}
                  />
                )}
              />
              {isSelectedMethodEmpty && (
                <ValidationMessage message={"Please Select Discount Method."} />
              )}
            </Grid>
          )}

          {selectedOfferType.id === "BUY_X_GET_Y_CHEAPEST_DISCOUNTED"
            ? selectedDiscountMethod?.id !== "FREE" && (
                <Grid item xs={4}>
                  <Typography variant="body2" style={{ fontWeight: "bold" }}>
                    {selectedDiscountMethod?.id === "FIXED"
                      ? "Fixed Value"
                      : "Discounted Percentage"}
                  </Typography>
                  <TextfieldDefault
                    key={`${selectedOfferType.id}-${selectedDiscountMethod?.id}`}
                    id="discountValue"
                    name="discountValue"
                    type="number"
                    label=""
                    style={{
                      border: `1px solid ${theme.palette.background.entity_border}`,
                    }}
                    inputRef={register({
                      required: "Fixed Total Price is required.",
                      min: {
                        value: 1,
                        message: "Fixed Total Price must be greater than 0.",
                      },
                      ...(selectedOfferType.id ===
                        "BUY_X_GET_Y_CHEAPEST_DISCOUNTED" &&
                      selectedDiscountMethod?.id === "PERCENTAGE"
                        ? {
                            pattern: {
                              value: /^[0-9]+$/,
                              message: "Only whole numbers are allowed.",
                            },
                          }
                        : {}),
                    })}
                    inputProps={{
                      ...(selectedOfferType.id ===
                        "BUY_X_GET_Y_CHEAPEST_DISCOUNTED" &&
                      selectedDiscountMethod?.id === "PERCENTAGE"
                        ? { step: 1 }
                        : { step: "0.01" }),
                      min: 1,
                    }}
                  />
                  {errors.discountValue ? (
                    <ValidationMessage message={errors.discountValue.message} />
                  ) : (
                    ""
                  )}
                </Grid>
              )
            : selectedOfferType?.id && (
                <Grid item xs={12}>
                  <Typography variant="body2" style={{ fontWeight: "bold" }}>
                    Fixed Total Price
                  </Typography>
                  <TextfieldDefault
                    id="fixedTotalPrice"
                    name="fixedTotalPrice"
                    type="number"
                    label=""
                    style={{
                      border: `1px solid ${theme.palette.background.entity_border}`,
                    }}
                    inputRef={register({
                      required: "Fixed Total Price is required.",
                      min: {
                        value: 1,
                        message: "Fixed Total Price greater than 0",
                      },
                    })}
                  />
                  {errors.fixedTotalPrice ? (
                    <ValidationMessage
                      message={errors.fixedTotalPrice.message}
                    />
                  ) : (
                    ""
                  )}
                </Grid>
              )}

          {selectedOfferType?.id === "BUY_X_GET_Y_CHEAPEST_DISCOUNTED" && (
            <Grid
              item
              xs={selectedDiscountMethod?.id === "FREE" ? 6 : 4}
              style={{ marginTop: "4px", marginBottom: "4px" }}
            >
              <Typography
                variant="body2"
                style={{ fontWeight: "bold", marginBottom: "2px" }}
              >
                Apply To
              </Typography>
              <Autocomplete
                open={isOpenApplyTo}
                onOpen={() => setIsOpenApplyTo(true)}
                onClose={() => setIsOpenApplyTo(false)}
                size={"small"}
                id="locationSelectGlobal"
                value={selectedApplyTo || []} // Ensure value is always an array
                getOptionLabel={(option) => option.label || ""}
                color="inherit"
                options={applyToList}
                disableClearable
                onChange={handleChangeApplyTo}
                classes={{ root: classes.autoComplete }}
                popupIcon={<ArrowDropDownIcon color={"inherit"} />}
                renderOption={(props: any) => {
                  return (
                    <Grid
                      container
                      {...props}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        zIndex: 0,
                        height: "20px",
                        marginBottom: "4px",
                      }}
                    >
                      <Grid item xs={12}>
                        <Typography
                          variant="body2"
                          className={classes.titleColor}
                        >
                          {props.label}
                        </Typography>
                      </Grid>
                    </Grid>
                  );
                }}
                // renderTags={(value, props) =>
                //   value.map((option, index) => (
                //     <Chip label={option} {...props({ index })} />
                //   ))
                // }
                renderInput={(params: any) => (
                  <TextField
                    color="inherit"
                    {...params}
                    label=""
                    variant="outlined"
                    InputProps={{
                      ...params.InputProps,
                      style: { height: 42 },
                    }}
                  />
                )}
              />
              {isApplyToEmpty && (
                <ValidationMessage message={"Please Select Apply To."} />
              )}
            </Grid>
          )}
          {selectedOfferType?.id && (
            <Grid item xs={6}>
              <FormControlLabel
                control={<SwitchCommon />}
                checked={isAllowRepeatInBasket}
                onChange={handleAllowRepeatInBasketActivate}
                style={{
                  marginLeft: "2px",
                  marginBottom:
                    selectedOfferType.id === "FIXED_PRICE_FROM_X_LISTS"
                      ? "0px"
                      : "20px",
                }}
                label={
                  <Typography variant="caption" color="textSecondary">
                    Allow Repeat In Basket
                  </Typography>
                }
                labelPlacement="start"
              />
            </Grid>
          )}
          {(selectedOfferType.id === "BUY_X_GET_Y_CHEAPEST_DISCOUNTED" ||
            selectedOfferType.id === "FIXED_PRICE_FOR_X_ITEMS") && (
            <Grid item xs={12} style={{ marginBottom: "20px" }}>
              <ButtonCommon
                style={{
                  flex: 1,
                  fontSize: 11,
                  marginRight: 4,
                  width: "100%",
                  marginBottom: "12px",
                  display: "flex",
                  justifyContent: "space-between",
                  textTransform: "none",
                }}
                variant="contained"
                color={"green"}
                onClick={handleOpenProductsAddModal}
              >
                <Typography style={{ color: "white" }}>
                  {(() => {
                    const counts = Object.values(selectedWrapperIdList).reduce(
                      (acc: any, item: any) => {
                        return acc + Object.keys(item).length;
                      },
                      0,
                    );

                    return `${counts} ${
                      counts === 1 ? "product" : "products"
                    } selected`;
                  })()}
                </Typography>
                <Typography style={{ color: "white" }}>Set Products</Typography>
              </ButtonCommon>
              {isMembersEmpty && (
                <ValidationMessage message={"Members can not be empty"} />
              )}
            </Grid>
          )}
          {selectedOfferType.id === "FIXED_PRICE_FROM_X_LISTS" && (
            <ThirdTypeGroup
              setGroupInfo={setGroupInfo}
              groupInfo={groupInfo}
              isMembersEmptyOrMinTwo={isMembersEmpty}
              offerItemMap={offerItemMap}
              setOfferItemMap={setOfferItemMap}
              offerItemMapInitial={offerItemMapInitial}
              selectedWrapperIdListInitialNew={selectedWrapperIdListInitialNew}
              isActive={isActive}
              offerName={offerName}
            />
          )}
        </Grid>
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginBottom: "12px",
          }}
        >
          <ButtonCommon
            isLoadingPage={isLoadingButton}
            style={{
              flex: 1,
              fontSize: 11,
              marginRight: 4,
              minWidth: 160,
            }}
            variant="contained"
            color={"yellow"}
            onClick={() => {
              setOfferItemMap(offerItemMapInitial);
              setOpenDialog(false);
            }}
          >
            Cancel
          </ButtonCommon>
          <ButtonCommon
            isLoadingPage={isLoadingButton}
            style={{
              flex: 1,
              fontSize: 11,
              marginRight: 4,
              minWidth: 160,
              marginLeft: 20,
            }}
            variant="contained"
            color={"green"}
            onClick={handleSubmitData}
          >
            {submitButtonName.CREATE_SUBMIT_BUTTON}
          </ButtonCommon>
        </div>
      </Grid>
    </>
  );
};

export default OfferModalDialog;
